// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ab68853","453":"00cd953a","455":"767fa2ed","977":"28fa09f2"}[chunkId] + ".chunk.js";
};